import {
  FETCH_POP_COUNT,
  FETCH_LIVESERVICE_COUNT,
  FETCH_USERACTIVITY_COUNT,
  FETCH_CUSTOMER_AM,
  FETCH_QUICK_LINKS,
  FETCH_PENDING_ACTION_DATA,
  FETCH_INCIDENT_DASHBOARD_DATA,
  FETCH_DEMAND_DASHBOARD_DATA,
  FETCH_ONBOARDED_CUSTOMER_COUNT,
  FETCH_ONBOARDING_REQUEST_DATA,
  FETCH_SCHEDULED_BROADCAST_MESSAGE,
  FETCH_CUSTOMER_DETAILS_WIDGET,
  FETCH_CUSTOMER_PRIMARY_CONTACT,
  FETCH_SELECTED_CUSTOMER_AM,
  FETCH_CUSTOMER_APPROVER_WIDGET,
  FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT,
  FETCH_STATUS_WISE_INTERNAL_USERS_COUNT,
} from "../../actions/actionTypes";

const initialState = {
  popsCount: {
    data: {},
    isLoading: false,
  },
  liveServiceCount: {
    data: {},
    isLoading: false,
  },
  userActivityCount: {
    data: {},
    isLoading: false,
  },
  onBoardedCustomerCount: {
    data: {},
    isLoading: false,
  },
  incidentGraphData: {
    data: {},
    isLoading: false,
  },
  demandGraphData: {
    data: {},
    isLoading: false,
  },
  onBoardingRequestData: {
    data: {},
    isLoading: false,
  },
  pendingActionData: {
    data: {},
    isLoading: false,
  },
  quickLinks: {
    data: {},
    isLoading: false,
  },
  scheduledBroadCastMessage: {
    data: {},
    isLoading: false,
  },
  customerAm: {
    data: {},
    isLoading: false,
  },
  customerData: {
    data: {},
    isLoading: false,
  },
  customerPrimaryContact: {
    data: {},
    isLoading: false,
  },
  selectedCustomerAM: {
    data: {},
    isLoading: false,
  },
  selectedCustomerApprover: {
    data: {},
    isLoading: false,
  },
  statusWiseCustomerUserCount: {
    data: {},
    isLoading: false,
  },
  statusWiseInternalUserCount: {
    data: {},
    isLoading: false,
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // PoPs Count
    case FETCH_POP_COUNT.REQUEST:
      return {
        ...state,
        popsCount: { ...state.popsCount, isLoading: true },
      };
    case FETCH_POP_COUNT.SUCCESS:
      return {
        ...state,
        popsCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_POP_COUNT.FAILURE:
      return {
        ...state,
        popsCount: { ...state.popsCount, isLoading: false },
      };

    // Live Service Count
    case FETCH_LIVESERVICE_COUNT.REQUEST:
      return {
        ...state,
        liveServiceCount: { ...state.liveServiceCount, isLoading: true },
      };
    case FETCH_LIVESERVICE_COUNT.SUCCESS:
      return {
        ...state,
        liveServiceCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_LIVESERVICE_COUNT.FAILURE:
      return {
        ...state,
        liveServiceCount: { ...state.liveServiceCount, isLoading: false },
      };

    // User Activity Count
    case FETCH_USERACTIVITY_COUNT.REQUEST:
      return {
        ...state,
        userActivityCount: { ...state.userActivityCount, isLoading: true },
      };
    case FETCH_USERACTIVITY_COUNT.SUCCESS:
      return {
        ...state,
        userActivityCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_USERACTIVITY_COUNT.FAILURE:
      return {
        ...state,
        userActivityCount: { ...state.userActivityCount, isLoading: false },
      };
    // Onboarded Customer Count
    case FETCH_ONBOARDED_CUSTOMER_COUNT.REQUEST:
      return {
        ...state,
        onBoardedCustomerCount: { ...state.onBoardedCustomerCount, isLoading: true },
      };
    case FETCH_ONBOARDED_CUSTOMER_COUNT.SUCCESS:
      return {
        ...state,
        onBoardedCustomerCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_ONBOARDED_CUSTOMER_COUNT.FAILURE:
      return {
        ...state,
        onBoardedCustomerCount: { ...state.onBoardedCustomerCount, isLoading: false },
      };
    // Incident grapg data
    case FETCH_INCIDENT_DASHBOARD_DATA.REQUEST:
      return {
        ...state,
        incidentGraphData: { ...state.incidentGraphData, isLoading: true },
      };
    case FETCH_INCIDENT_DASHBOARD_DATA.SUCCESS:
      return {
        ...state,
        incidentGraphData: { data: action.obj.data, isLoading: false },
      };
    case FETCH_INCIDENT_DASHBOARD_DATA.FAILURE:
      return {
        ...state,
        incidentGraphData: { ...state.incidentGraphData, isLoading: false },
      };
    // Demand grapg data
    case FETCH_DEMAND_DASHBOARD_DATA.REQUEST:
      return {
        ...state,
        demandGraphData: { ...state.demandGraphData, isLoading: true },
      };
    case FETCH_DEMAND_DASHBOARD_DATA.SUCCESS:
      return {
        ...state,
        demandGraphData: { data: action.obj.data, isLoading: false },
      };
    case FETCH_DEMAND_DASHBOARD_DATA.FAILURE:
      return {
        ...state,
        demandGraphData: { ...state.demandGraphData, isLoading: false },
      };
    // Onboarding request data
    case FETCH_ONBOARDING_REQUEST_DATA.REQUEST:
      return {
        ...state,
        onBoardingRequestData: { ...state.onBoardingRequestData, isLoading: true },
      };
    case FETCH_ONBOARDING_REQUEST_DATA.SUCCESS:
      return {
        ...state,
        onBoardingRequestData: { data: action.obj.data, isLoading: false },
      };
    case FETCH_ONBOARDING_REQUEST_DATA.FAILURE:
      return {
        ...state,
        onBoardingRequestData: { ...state.onBoardingRequestData, isLoading: false },
      };
    // Pending Action
    case FETCH_PENDING_ACTION_DATA.REQUEST:
      return {
        ...state,
        pendingActionData: { ...state.pendingActionData, isLoading: true },
      };
    case FETCH_PENDING_ACTION_DATA.SUCCESS:
      return {
        ...state,
        pendingActionData: { data: action.obj.data, isLoading: false },
      };
    case FETCH_PENDING_ACTION_DATA.FAILURE:
      return {
        ...state,
        pendingActionData: { ...state.pendingActionData, isLoading: false },
      };
    // Get Quick Links
    case FETCH_QUICK_LINKS.REQUEST:
      return {
        ...state,
        quickLinks: { ...state.quickLinks, isLoading: true },
      };
    case FETCH_QUICK_LINKS.SUCCESS:
      return {
        ...state,
        quickLinks: { data: action.obj.data, isLoading: false },
      };
    case FETCH_QUICK_LINKS.FAILURE:
      return {
        ...state,
        quickLinks: { ...state.quickLinks, isLoading: false },
      };
    // Get Schedule Broadcast Message
    case FETCH_SCHEDULED_BROADCAST_MESSAGE.REQUEST:
      return {
        ...state,
        scheduledBroadCastMessage: { ...state.scheduledBroadCastMessage, isLoading: true },
      };
    case FETCH_SCHEDULED_BROADCAST_MESSAGE.SUCCESS:
      return {
        ...state,
        scheduledBroadCastMessage: { data: action.obj.data, isLoading: false },
      };
    case FETCH_SCHEDULED_BROADCAST_MESSAGE.FAILURE:
      return {
        ...state,
        scheduledBroadCastMessage: { ...state.scheduledBroadCastMessage, isLoading: false },
      };
    // User Customer AM
    case FETCH_CUSTOMER_AM.REQUEST:
      return {
        ...state,
        customerAm: { ...state.customerAm, isLoading: true },
      };
    case FETCH_CUSTOMER_AM.SUCCESS:
      return {
        ...state,
        customerAm: { data: action.obj.data, isLoading: false },
      };
    case FETCH_CUSTOMER_AM.FAILURE:
      return {
        ...state,
        customerAm: { ...state.customerAm, isLoading: false },
      };
    // get selected Customer data
    case FETCH_CUSTOMER_DETAILS_WIDGET.REQUEST:
      return {
        ...state,
        customerData: { ...state.customerData, isLoading: true },
      };
    case FETCH_CUSTOMER_DETAILS_WIDGET.SUCCESS:
      return {
        ...state,
        customerData: { data: action.obj.data, isLoading: false },
      };
    case FETCH_CUSTOMER_DETAILS_WIDGET.FAILURE:
      return {
        ...state,
        customerData: { ...state.customerData, isLoading: false },
      };
    // get selected Customer Primary Contact Data
    case FETCH_CUSTOMER_PRIMARY_CONTACT.REQUEST:
      return {
        ...state,
        customerPrimaryContact: { ...state.customerPrimaryContact, isLoading: true },
      };
    case FETCH_CUSTOMER_PRIMARY_CONTACT.SUCCESS:
      return {
        ...state,
        customerPrimaryContact: { data: action.obj.data, isLoading: false },
      };
    case FETCH_CUSTOMER_PRIMARY_CONTACT.FAILURE:
      return {
        ...state,
        customerPrimaryContact: { ...state.customerPrimaryContact, isLoading: false },
      };
     // get selected Customer AM
     case FETCH_SELECTED_CUSTOMER_AM.REQUEST:
      return {
        ...state,
        selectedCustomerAM: { ...state.selectedCustomerAM, isLoading: true },
      };
    case FETCH_SELECTED_CUSTOMER_AM.SUCCESS:
      return {
        ...state,
        selectedCustomerAM: { data: action.obj.data, isLoading: false },
      };
    case FETCH_SELECTED_CUSTOMER_AM.FAILURE:
      return {
        ...state,
        selectedCustomerAM: { ...state.selectedCustomerAM, isLoading: false },
      };
     // get selected Customer Approver
     case FETCH_CUSTOMER_APPROVER_WIDGET.REQUEST:
      return {
        ...state,
        selectedCustomerApprover: { ...state.selectedCustomerApprover, isLoading: true },
      };
    case FETCH_CUSTOMER_APPROVER_WIDGET.SUCCESS:
      return {
        ...state,
        selectedCustomerApprover: { data: action.obj.data, isLoading: false },
      };
    case FETCH_CUSTOMER_APPROVER_WIDGET.FAILURE:
      return {
        ...state,
        selectedCustomerApprover: { ...state.selectedCustomerApprover, isLoading: false },
      };
    // get status wise Customer User Count
    case FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.REQUEST:
      return {
        ...state,
        statusWiseCustomerUserCount: { ...state.statusWiseCustomerUserCount, isLoading: true },
      };
    case FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.SUCCESS:
      return {
        ...state,
        statusWiseCustomerUserCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_STATUS_WISE_CUSTOMER_USERS_COUNT.FAILURE:
      return {
        ...state,
        statusWiseCustomerUserCount: { ...state.statusWiseCustomerUserCount, isLoading: false },
      };
    // get status wise Internal User Count
    case FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.REQUEST:
      return {
        ...state,
        statusWiseInternalUserCount: { ...state.statusWiseInternalUserCount, isLoading: true },
      };
    case FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.SUCCESS:
      return {
        ...state,
        statusWiseInternalUserCount: { data: action.obj.data, isLoading: false },
      };
    case FETCH_STATUS_WISE_INTERNAL_USERS_COUNT.FAILURE:
      return {
        ...state,
        statusWiseInternalUserCount: { ...state.statusWiseInternalUserCount, isLoading: false },
      };
    default:
      return state;
  }
};

export default reducer;
